import { createAsyncThunk } from '@reduxjs/toolkit'
import { getAuth, signOut } from 'firebase/auth'
import { OAuthService } from '../../../services/oauth'
import { clearLicense } from '../license'
import { clearStations } from '../station'
import { setIsLogoutDialog } from './index'

export const logout = createAsyncThunk('app/logout', async (_, { dispatch }) => {
    dispatch(setIsLogoutDialog(false))

    const auth = getAuth()

    await signOut(auth)

    await OAuthService.removeTokensFromStorage()

    dispatch(clearStations())
    dispatch(clearLicense())
})
